import { BaseItemStore } from "../../core/BaseStore";
import type BusinessModuleModel from "./BusinessModuleModel";
import type { BusinessModuleModelData, Snapshot } from "./BusinessModuleModel";

export default class BusinessModulesStore extends BaseItemStore<
  BusinessModuleModel<Snapshot, BusinessModuleModelData<Snapshot>>
> {}
